import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import partners from '../assets/partners.png';

export default function PartnersBanner(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const partnersList = [
    { name: "Nebura", country: "India", initials: "N" },
    { name: "Trivitron", country: "Africa", initials: "T" },
    { name: "Amcaremed", country: "China", initials: "A" },
    { name: "MR", country: "India", initials: "MR" },
    { name: "Skyfavor", country: "China", initials: "S" },
    { name: "Precision UK LTD", country: "UK", initials: "P" },
    { name: "Afrimed", country: "Dubai", initials: "AF" }
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">{getInlineLoader()}</div>
    );
  }

  return (
    <div
      className="MainBodySection bg-surface"
      style={{ paddingTop: "50px", paddingBottom: "50px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="main-section-title">
              Our Business Partners
              <span
                style={{
                  display: "block",
                  borderBottom: "3px solid var(--secondaryColor)",
                  width: "50px",
                  marginTop: "10px",
                }}
              ></span>
            </h6>
          </div>

          <div className="col-md-12">
            <div className="partners-slider-wrapper position-relative overflow-hidden">
              <div className="partners-slider d-flex align-items-center">
                {[...partnersList, ...partnersList].map((partner, i) => (
                  <div
                    key={i}
                    className="partner-card text-center mx-3 flex-shrink-0"
                    style={{ width: "140px" }}
                  >
                    <div
                      className="partner-logo d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2"
                      style={{
                        width: "80px",
                        height: "80px",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        background: `linear-gradient(135deg, hsl(${(i * 40) % 360}, 70%, 50%), hsl(${(i * 40 + 60) % 360}, 70%, 60%))`,
                      }}
                    >
                      {partner.initials}
                    </div>
                    <div className="fw-medium font-bold">{partner.name}</div>
                    <div className="text-muted small">{partner.country}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .partners-slider {
          animation: slideLeft 25s linear infinite;
          width: max-content;
        }

        .partners-slider-wrapper {
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .partners-slider { animation-duration: 35s; }
        }

        @media (prefers-reduced-motion: reduce) {
          .partners-slider { animation: none; }
        }
      `}</style>
    </div>
  );
}
